import { render, staticRenderFns } from "./AssignLog.vue?vue&type=template&id=1baaf52a&scoped=true&"
import script from "./AssignLog.vue?vue&type=script&lang=js&"
export * from "./AssignLog.vue?vue&type=script&lang=js&"
import style0 from "./AssignLog.vue?vue&type=style&index=0&id=1baaf52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baaf52a",
  null
  
)

export default component.exports